import React, { useEffect } from 'react';
import TextInput from '../../../elements/TextInput/TextInput';
import OpenModalButton from '../../../elements/OpenModalButton/ui/OpenModalButton';
import TagInput from '../../../elements/TagInput/TagInput';
import DropdownUnit from '../../../../common/components/DropdownUnit';
import { units } from '../../../adform/constants/units';
import { t } from 'i18next';
import warning_icon from '../../../../assets/icons/WarningCircle.svg';
import CharacteristicsFields from '../../../../common/components/CharacteristicsFields';

export function DemandForm({
    title,
    setTitle,
    description,
    setDescription,
    maxPrice,
    setMaxPrice,
    selectedCategory,
    setSelectedCategory,
    selectedSubcategory,
    setSelectedSubcategory,
    keywords,
    setKeywords,
    keywordsArray,
    setKeywordsArray,
    measurementUnit,
    setMeasurementUnit,
    quantity,
    setQuantity,
    isSubmitted,
    jsonData,
    setJsonData,
}) {
    const handleSelectCategory = (selection) => {
        if (selection.categoryId) {
            setSelectedCategory(selection.categoryId);
            localStorage.setItem("selectedCategory", selection.categoryId);
        }
        if (selection.subcategoryId) {
            setSelectedSubcategory(selection.subcategoryId);
            localStorage.setItem("selectedSubcategory", selection.subcategoryId);
        }
    };

    const handleKeywordsChange = (e) => {
        setKeywords(e.target.value);
    };

    const handleAddKeyword = () => {
        const input = keywords.trim();
        if (!input) return;

        // Бөлгіштер: , . ;
        const rawTags = input.split(/[.,;]+/);
        const newKeywords = [...keywordsArray];

        for (const raw of rawTags) {
            const tag = raw.trim();
            if (tag.length >= 2 && !newKeywords.includes(tag)) {
                newKeywords.push(tag);
            }
        }

        if (newKeywords.length !== keywordsArray.length) {
            setKeywordsArray(newKeywords);
        }
        setKeywords('');
    };

    const handleRemoveKeyword = (index) => {
        setKeywordsArray(keywordsArray.filter((_, i) => i !== index));
    };

    useEffect(() => {
        const savedCategory = localStorage.getItem("selectedCategory");
        const savedSubcategory = localStorage.getItem("selectedSubcategory");
        if (savedCategory) setSelectedCategory(savedCategory);
        if (savedSubcategory) setSelectedSubcategory(savedSubcategory);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="demand_form_container">
            <div className="demand_field_section bg-[var(--background-white-color)] rounded-[10px] p-5 mt-2.5">
                <TextInput
                    isRequired={true}
                    onInputChange={(value) => setTitle(value)}
                    isSubmitted={isSubmitted}
                    errorText={t('required_text')}
                    labelText={t('demand_title')}
                    placeholder={t('demand_title_placeholder')}
                    type="text"
                    value={title}
                />
            </div>

            <div className="demand_field_section bg-[var(--background-white-color)] rounded-[10px] p-5 mt-2.5">
                <TextInput
                    isRequired={true}
                    onInputChange={(value) => setDescription(value)}
                    isSubmitted={isSubmitted}
                    errorText={t('required_text')}
                    labelText={t('description')}
                    placeholder={t('demand_description_placeholder')}
                    type="text"
                    value={description}
                />
            </div>

            <div className="demand_field_section bg-[var(--background-white-color)] rounded-[10px] p-5 mt-2.5">
                <label className="text_input_label">{t('category')}</label>
                <OpenModalButton
                    type="category"
                    onSelect={handleSelectCategory}
                    selectedCategoryId={selectedCategory}
                    selectedSubcategoryId={selectedSubcategory}
                    placeholder={t('select_category')}
                />
                {isSubmitted && (!selectedCategory || !selectedSubcategory) && (
                    <div className="input_header">
                        <span className="error_text">{t('required_text')}</span>
                        <img src={warning_icon} alt='warning' />
                    </div>
                )}
            </div>

            {selectedCategory && setJsonData && (
                <CharacteristicsFields
                    categoryId={selectedCategory}
                    values={jsonData || {}}
                    onChange={setJsonData}
                />
            )}

            <div className="demand_field_section bg-[var(--background-white-color)] rounded-[10px] p-5 mt-2.5">
                <label className="text_input_label">{t('max_price')}</label>
                <input
                    type="number"
                    className="phone_input price_input flex-1 min-w-0"
                    placeholder={t('max_price')}
                    value={maxPrice || ''}
                    onChange={(e) => setMaxPrice(e.target.value)}
                />
            </div>

            <div className="demand_field_section bg-[var(--background-white-color)] rounded-[10px] p-5 mt-2.5">
                <label className="text_input_label">{t('quantity')}</label>
                <div className="flex gap-2.5 items-center w-full">
                    <input
                        type="number"
                        className="phone_input price_input flex-1 min-w-0"
                        placeholder={t('quantity')}
                        value={quantity || ''}
                        onChange={(e) => setQuantity(e.target.value)}
                    />
                    <div className="flex-1 min-w-0">
                        <DropdownUnit
                            text={t('select_unit')}
                            options={units}
                            selected={measurementUnit}
                            onOptionSelect={setMeasurementUnit}
                        />
                    </div>
                </div>
                {isSubmitted && !measurementUnit && (
                    <div className="input_header">
                        <span className="error_text">{t('required_text')}</span>
                        <img src={warning_icon} alt='warning' />
                    </div>
                )}
            </div>

            <div className="demand_field_section bg-[var(--background-white-color)] rounded-[10px] p-5 mt-2.5">
                <TagInput
                    value={keywords}
                    onChange={handleKeywordsChange}
                    onAddTag={handleAddKeyword}
                    onRemoveTag={handleRemoveKeyword}
                    tags={keywordsArray}
                    placeholder={t('keywords_placeholder')}
                />
            </div>
        </div>
    );
}

